import { render, staticRenderFns } from "./BankPixType.vue?vue&type=template&id=7e72f331"
import script from "./BankPixType.vue?vue&type=script&lang=js"
export * from "./BankPixType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports